var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram-icon",
    transform: "translate(-1235 -4666)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 40,
    height: 41,
    rx: 7,
    transform: "translate(1235 4666)",
    fill: "rgba(102,170,71,0.19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(1243.211 4675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_112_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    d: "M346.553,329.96H335.54a6.266,6.266,0,0,0-6.14,6.349V347.2a6.264,6.264,0,0,0,6.14,6.349h11.013a6.266,6.266,0,0,0,6.14-6.349V336.309a6.266,6.266,0,0,0-6.14-6.349Zm4.054,17.079a4.338,4.338,0,0,1-4.248,4.4H335.739a4.338,4.338,0,0,1-4.247-4.4V336.467a4.338,4.338,0,0,1,4.247-4.4H346.36a4.338,4.338,0,0,1,4.248,4.4Z",
    transform: "translate(-329.4 -329.96)",
    fill: "#66aa47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_114_",
    d: "M440.12,432.39a6.14,6.14,0,1,0,6.011,6.138A6.075,6.075,0,0,0,440.12,432.39Zm0,10.1a3.961,3.961,0,1,1,3.878-3.96,3.92,3.92,0,0,1-3.878,3.96Z",
    transform: "translate(-428.628 -426.563)",
    fill: "#66aa47"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_71_",
    cx: 1.358,
    cy: 1.387,
    rx: 1.358,
    ry: 1.387,
    transform: "translate(16.467 4.111)",
    fill: "#66aa47"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.55181ef9a060fa6101d7680991b8a6c4.svg";
export { ForwardRef as ReactComponent };